/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FuelStatistics,
    FuelStatisticsFromJSON,
    FuelStatisticsFromJSONTyped,
    FuelStatisticsToJSON,
} from './';

/**
 * 
 * @export
 * @interface FuelStatisticsEntryDriver
 */
export interface FuelStatisticsEntryDriver {
    /**
     * 
     * @type {number}
     * @memberof FuelStatisticsEntryDriver
     */
    driverId: number;
    /**
     * 
     * @type {FuelStatistics}
     * @memberof FuelStatisticsEntryDriver
     */
    stats: FuelStatistics;
}

export function FuelStatisticsEntryDriverFromJSON(json: any): FuelStatisticsEntryDriver {
    return FuelStatisticsEntryDriverFromJSONTyped(json, false);
}

export function FuelStatisticsEntryDriverFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelStatisticsEntryDriver {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'driverId': json['driver_id'],
        'stats': FuelStatisticsFromJSON(json['stats']),
    };
}

export function FuelStatisticsEntryDriverToJSON(value?: FuelStatisticsEntryDriver | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'driver_id': value.driverId,
        'stats': FuelStatisticsToJSON(value.stats),
    };
}


